import { useMsal } from "@azure/msal-react";
import {
  CircularProgress,
  Container,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  Divider,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  TextField,
} from "@material-ui/core";
import { FilterList, ArrowForward, Close } from "@material-ui/icons";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./trendsStyle";
import ZeitFilter from "../../../features/filter/zeit";
import {
  selectIsChangedZeit,
  setEndeCounter,
  setEndeZeitraum,
  setStartCounter,
  setStartDatum,
  setStartZeitraum,
  selectStartDatumTemp,
  setEndeDatum,
  selectEndeDatumTemp,
  setIsChangedZeit,
  selectEndeCounterTemp
} from "../../../features/filter/zeitSlice";
import MessstellenFilter from "../../../features/filter/messstellen";
import KenngroesseFilter from "../../../features/filter/kenngroesse";
import {
  getKenngroesse,
  setKenngroesseWert,
  selectKenngroesseWertTemp,
  selectIsChangedKenngroesse,
  setIsChangedKenngroesse,
} from "../../../features/filter/kenngroesseSlice";
import {
  getMessstellen,
  setMessstelleWert,
  selectMessstelleWertTemp,
  selectIsChangedMessstelle,
  setIsChangedMessstelle,
} from "../../../features/filter/messstellenFilterSlice";
import TrendsFilter from "./trendsFilter";
import {
  setAktuellerWert,
  selectAktuellerWertTemp,
  selectIsFirstInitLoad,
  setIsChangedTrends,
  setAktuellerAnstieg,
  setAktuellerAnstiegWert,
  setAktuellerAnstiegsdauer,
  setAktuellerAnstiegsdauerWert,
  setMittlererAnstieg,
  setMittlererAnstiegWert,
  setIsFirstInitLoad,
  selectAktuellerTemp,
  selectAktuellerAnstiegTemp,
  selectAktuellerAnstiegsdauerTemp,
  selectMittlererAnstiegTemp,
  // selectAktuellerWert,
  // selectAktuellerAnstiegWert,
  // selectAktuellerAnstiegsdauerWert,
  // selectMittlererAnstiegWert,
  selectAktuellerAnstiegWertTemp,
  selectAktuellerAnstiegsdauerWertTemp,
  selectMittlererAnstiegWertTemp,
  getCalculatedTrends,
  selectselectedCalculatedTrend
} from "./trendsFilterSlice";
import {
  selectSelectedTab,
  selectSelectedTabVorher,
  selectTrendsGraphTabs,
  setRemoveGraphTab,
  setSelectedTab,
  setSelectedTabVorher,
  setIsOld,
  calculateTrend,
  selectIsGraphLoading
} from "./trendsSlice";
import {
  getTrendsTable,
  selectTrendsListe,
  selectIsLoadingTrendsTable,
} from "./trendsTableSlice";

import TrendsTable from "./trendsTable";
import TrendsGraph from "./trendsGraph";
import { useParams } from "react-router";
import { justNormalValidate, validateHelper } from "../../../features/validate/validate";



function Trends(): ReactElement {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const { id } = useParams<{id: string | undefined}>();
  
  useEffect(() => {
    dispatch(getCalculatedTrends(id));
    dispatch(getKenngroesse("trends"));
    dispatch(getMessstellen());
  }, [instance]);

  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };

  const isChangedZeit = useAppSelector(selectIsChangedZeit);
  const isChangedKenngroesse = useAppSelector(selectIsChangedKenngroesse);
  const isChangedMessstelle = useAppSelector(selectIsChangedMessstelle);
  const isInitFirstLoad = useAppSelector(selectIsFirstInitLoad);
  const loadingTrends = useAppSelector(selectIsLoadingTrendsTable);
  const trendsGeneralObject = useAppSelector(selectTrendsListe);

  const kenngroesse = useAppSelector(selectKenngroesseWertTemp);
  const messstelle = useAppSelector(selectMessstelleWertTemp);
  const startDate = useAppSelector(selectStartDatumTemp);
  const endeDate = useAppSelector(selectEndeDatumTemp);
  const endDateField = useAppSelector(selectEndeCounterTemp);

  // const aktueller = useAppSelector(selectAktuellerWertTemp);
  const aktuellerTemp = useAppSelector(selectAktuellerTemp);
const aktuellerAnstiegTemp = useAppSelector(selectAktuellerAnstiegTemp);
const aktuellerAnstiegsdauerTemp = useAppSelector(selectAktuellerAnstiegsdauerTemp);
const mittlererAnstiegTemp = useAppSelector(selectMittlererAnstiegTemp);

const aktuellerWert = useAppSelector(selectAktuellerWertTemp);
const aktuellerAnstiegWert = useAppSelector(selectAktuellerAnstiegWertTemp);
const aktuellerAnstiegsdauerWert = useAppSelector(selectAktuellerAnstiegsdauerWertTemp);
const mittlererAnstiegWert = useAppSelector(selectMittlererAnstiegWertTemp);

const selectedTab = useAppSelector(selectSelectedTab);
const selectedTabVorher = useAppSelector(selectSelectedTabVorher);
const trendsGraphTabs = useAppSelector(selectTrendsGraphTabs);

const selectedCalculatedTrend = useAppSelector(selectselectedCalculatedTrend);

const isGraphLoading = useAppSelector(selectIsGraphLoading);

const [selectedTabFilter, setSelectedTabFilter] = React.useState("trends");
const [filter, openFilter] = React.useState(true);

const [isDialogOpen, setDialogOpen] = React.useState(false);
const [anfrageName, setAnfrageName] = React.useState('');
const [dialogError, setDialogError] = React.useState(false);

function closeTab(tab: string, listLength: number) {
  if (listLength == 1) {
    dispatch(setSelectedTab("trendsTable"));
  } else if (selectedTab == tab) {
    dispatch(setSelectedTab(selectedTabVorher));
  }
}

  return (
    <div style={{position: "relative"}}>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Trends
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <Paper
        className={classes.paper}
        style={{
          marginLeft: "24px",
          marginRight: "24px",
          marginBottom: "10px",
        }}
      >
        <form
          className={classes.root}
          noValidate
          autoComplete="off"
          style={{ marginBottom: "10px" }}
        >
          <div>
            <Grid container spacing={4} style={{ marginBottom: "10px" }}>
              <Grid container item md={12} style={{ paddingLeft: "16px"}}>
                <Grid container item xs={12} >
                  <Grid item xs={11} ></Grid>
                    {filter ? 
                  <Grid item xs={1} style={{ textAlign: "end" }}>
                    <IconButton onClick={() =>{ openFilter(false)}}>
                      <Tooltip title="Filter zuklappen">
                        <ArrowForward />
                      </Tooltip>
                    </IconButton> 
                  </Grid> 
                    : 
                  <Grid item xs={1} style={{ textAlign: "end"}}>
                      <IconButton onClick={() => {openFilter(true)}}>
                    <Tooltip title="Filter aufklappen">
                      <FilterList />
                    </Tooltip>
                  </IconButton>
                  </Grid>
                   } 
                </Grid>
                <Grid item md={filter ? 7 : 12}>
                  <Tabs
                    value={selectedTab}
                    onChange={(event, value) => {
                      dispatch(setSelectedTab(value));
                      dispatch(setSelectedTabVorher(selectedTab));
                    }}
                    indicatorColor="secondary"
                    textColor="secondary"
                    TabIndicatorProps={{
                      style: {
                        height: "5px",
                      },
                    }}
                  >
                    <Tab
                      fullWidth={true}
                      label="Übersicht"
                      value="trendsTable"
                      style={{ marginRight: "15px" }}
                    ></Tab>
                    {trendsGraphTabs.map((el) => (
                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: el.isOld ? "red" : "",
                        }}
                        key={el.index}
                        value={ el.index}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {el.name}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={el.index}
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    dispatch(setRemoveGraphTab(el))
                                    closeTab(
                                      el.index.toString(),
                                      trendsGraphTabs.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                      { isGraphLoading ? <Tab
                      fullWidth={true}
                      label={<CircularProgress
                      size="30px"
                    />}
                      value="loading"
                      style={{ marginRight: "15px" }}
                    ></Tab> : "" }
                  </Tabs>
                  <Grid item container xs={12}>
                    {
                      (trendsGraphTabs.map((el) =>
                            selectedTab == el.index.toString()  ? (
                            (
                              Object.entries(el.dataSet).map(([key, value]) =>  (  
                                <TrendsGraph  layout={ Object.entries(el.dataSet).length > 1 && !filter ? "double" : "single"}  chartID={el.name + key}
                                  trendsGraphItemProp={value} key={key} />
                                )
                            ))
                          ) : (
                            ""
                          )
                          )
                      )
                    }
                   </Grid>
                  {selectedTab == "trendsTable" ? (
                    loadingTrends ? (
                      <CircularProgress
                        size="30px"
                        style={{ marginTop: "100px", padding: "1px" }}
                      />
                    ) : trendsGeneralObject.length > 0 ? (
                      <Grid
                        container
                        item
                        md={12}
                        style={{ paddingTop: "20px"}}
                      >
                        <TrendsTable />

                      </Grid>
                    ) : (
                      <React.Fragment>
                        <Grid
                          item
                          md={12}
                          style={{
                            textAlign: "left",
                            marginRight: "20px",
                            marginLeft: "50px",
                            paddingTop: "100px",
                          }}
                        >
                          <div style={{ height: "30vh" }}>
                            {trendsGeneralObject.length == 0 
                            && !isInitFirstLoad 
                            ? (
                              <Typography>Keine Daten vorhanden.</Typography>
                            ) : (
                              <Typography>
                                Bitte Filter definieren, um Trends
                                anzuzeigen. Bestätigen Sie den Filter über
                                anzeigen.
                              </Typography>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    )
                  ) : (
                    ""
                  )}
                </Grid>
                {filter ? (
                  <React.Fragment>
                    <Grid item md={5} style={{ paddingLeft: "16px" }} >
                      <Grid
                        container
                        md={12}
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "24px",
                          paddingRight: "24px",
                          justifyContent: "end",
                         
                        }}
                      >
                        <Grid
                          container
                          md={1}
                          style={{
                            margin: "0px",
                            width: "10px",
                            maxWidth: "20px",
                            padding: "0px",
                           
                          }}
                        >
                          <Divider orientation="vertical" flexItem />
                        </Grid>
                        <Grid item container md={11}>
                          <Grid item md={12}>
                            <Tabs
                              value={selectedTabFilter}
                              onChange={(event, value) =>
                                setSelectedTabFilter(value)
                              }
                              indicatorColor="secondary"
                              textColor="secondary"
                              TabIndicatorProps={{
                                style: {
                                  height: "5px",
                                },
                              }}
                            >
                              <Tab label="Trends" value="trends" />
                              <Tab label="Zeit" value="zeit" />
                              <Tab label={"Messstelle ("+ messstelle.length +")"} value="messstelle" />
                              <Tab label={"Kenngröße ("+ kenngroesse.length +")"} value="kenngroesse" />
                            </Tabs>
                            {selectedTabFilter == "zeit" ? <ZeitFilter jahre={true}/> : ""}
                            {selectedTabFilter == "messstelle" ? (
                              <MessstellenFilter name={"trends"} />
                            ) : (
                              ""
                            )}
                            {selectedTabFilter == "kenngroesse" ? (
                              <KenngroesseFilter name={"trends"} />
                            ) : (
                              ""
                            )}
                            {selectedTabFilter == "trends" ? (
                              <TrendsFilter />
                            ) : (
                              ""
                            )}
                            <Grid
                              container
                              md={12}
                              style={{ marginTop: "30px" }}
                            >
                              <Grid item container md={6} />
                              <Grid
                                item
                                container
                                md={6}
                                style={{ justifyContent: "end" }}
                              >
                                {/* <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    dispatch(resetKenngroesseWert());
                                    dispatch(resetMessstelleWert());
                                    dispatch(resetEndeCounter());
                                    dispatch(resetStartCounter());
                                    dispatch(resetEndeZeitraum());
                                    dispatch(resetStartZeitraum());
                                    dispatch(resetStartDatum());
                                    dispatch(resetEndeDatum());
                                    dispatch(resetAktueller());
                                    dispatch(resetAktuellerWert());
                                    dispatch(resetAktuellerAnstieg());
                                    dispatch(resetAktuellerAnstiegWert());
                                    dispatch(resetAktuellerAnstiegsdauer());
                                    dispatch(resetAktuellerAnstiegsdauerWert());
                                    dispatch(resetMittlererAnstieg());
                                    dispatch(resetMittlererAnstiegWert());
                                    dispatch(setIsChangedMessstelle(false));
                                    dispatch(setIsChangedKenngroesse(false));
                                    dispatch(setIsChangedZeit(false));
                                    dispatch(setIsChangedTrends(false));
                                    dispatch(setIsOld(true));
                                  }}
                                  color="default"
                                  className={classes.showDuoButton}
                                  disabled={
                                    !isChangedZeit &&
                                    !isChangedKenngroesse &&
                                    !isChangedMessstelle 
                                  
                                  }
                                >
                                  Rückgängig
                                </Button> */}
                                <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    if(selectedCalculatedTrend?.id > 0) {
                                      dispatch(setIsChangedTrends(false));
                                      dispatch(
                                        getTrendsTable(selectedCalculatedTrend.id,
                                          kenngroesse,
                                          messstelle,
                                          aktuellerTemp == "Größer (>)" ? aktuellerWert : -1000000000, 
                                          aktuellerTemp == "Kleiner (<)" ? aktuellerWert : 1000000000,
                                          aktuellerAnstiegTemp == "Größer (>)" ? aktuellerAnstiegWert : -1000000000,
                                          aktuellerAnstiegTemp == "Kleiner (<)" ? aktuellerAnstiegWert : 1000000000,
                                          aktuellerAnstiegsdauerTemp == "Größer (>)" ? aktuellerAnstiegsdauerWert : -1000000000,
                                          aktuellerAnstiegsdauerTemp == "Kleiner (<)" ? aktuellerAnstiegsdauerWert : 1000000000,
                                          mittlererAnstiegTemp == "Größer (>)" ? mittlererAnstiegWert : -1000000000,
                                          mittlererAnstiegTemp == "Kleiner (<)" ? mittlererAnstiegWert : 1000000000,
                                        )
                                      );
                                  } else {
                                      setDialogOpen(true);
                                  }
                                  }}
                                  color="secondary"
                                  className={classes.showDuoButton}
                                disabled={
                                  // (!isChangedZeit &&
                                  //   !isChangedKenngroesse &&
                                  //   !isChangedMessstelle) || 
                                  ((kenngroesse.length == 0 ||
                                    messstelle.length == 0) ||
                                    (endeDate.getTime() - startDate.getTime()) < 53*7*24*3600*1000)
                                    && selectedCalculatedTrend?.id == null
                                }
                                >
                                  { selectedCalculatedTrend?.id > 0 ? "Anzeigen" : "Berechnen" }
                                </Button>
                                <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
                                    <DialogTitle>Name des neu zu berechnenden Trends</DialogTitle>
                                    <DialogContent>
                                        <DialogContentText>
                                            Bitte geben Sie einen Namen für den neu zu berechnenden Trend ein.
                                        </DialogContentText>
                                        <FormControl className={classes.fullWidth}>
                                            <TextField
                                                required={true}
                                                id="trend_anfrage_name"
                                                error={dialogError && justNormalValidate(anfrageName)}
                                                helperText={validateHelper(anfrageName)}
                                                label="Name"
                                                variant="outlined"
                                                onChange={(event) => setAnfrageName(event.target.value)}
                                                value={anfrageName}
                                            />
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            onClick={() => setDialogOpen(false)}
                                            className={classes.cancleDeleteButton}
                                        >
                                            Abbrechen
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                if (!justNormalValidate(anfrageName)) {
                                                  setDialogError(false);
                                                  dispatch(setKenngroesseWert());
                                                  dispatch(setMessstelleWert());
                                                  dispatch(setEndeZeitraum());
                                                  dispatch(setEndeCounter());
                                                  dispatch(setStartZeitraum());
                                                  dispatch(setStartCounter());
                                                  dispatch(setStartDatum());
                                                  dispatch(setEndeDatum());
                                                  dispatch(setAktuellerWert());
                                                  dispatch(setAktuellerAnstieg());
                                                  dispatch(setAktuellerAnstiegWert());
                                                  dispatch(setAktuellerAnstiegsdauer());
                                                  dispatch(setAktuellerAnstiegsdauerWert());
                                                  dispatch(setMittlererAnstieg());
                                                  dispatch(setMittlererAnstiegWert());
                                                  dispatch(setIsChangedMessstelle(false));
                                                  dispatch(setIsChangedKenngroesse(false));
                                                  dispatch(setIsChangedZeit(false));
                                                  dispatch(setIsChangedTrends(false));
                                                  dispatch(setIsOld(true));
                                                  dispatch(setIsFirstInitLoad(false));
                                                  dispatch(calculateTrend(anfrageName, startDate, endeDate,
                                                    messstelle.map(x => x.name), kenngroesse.map(x => x.feldname)));
                                                  setDialogOpen(false);
                                                  setAnfrageName("");
                                                } else {
                                                  setDialogError(true);
                                                }
                                            }}
                                            color={"secondary"}
                                            style={{ minWidth: "120px", minHeight: "36px" }}
                                        >
                                            {loadingTrends ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Abschicken"}
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ) : (

                  <React.Fragment>
                    <Grid item md={5} style={{ paddingLeft: "16px" }}>
                      <Grid
                        container
                        md={12}
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "24px",
                          paddingRight: "24px",
                          justifyContent: "end",
                          
                        }}
                      >
                        
                      </Grid>
                    </Grid>
                  </React.Fragment>
                  
                )}
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    </div>
  );
}

export default Trends;
